import { createReducer } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import sessionStorage from 'redux-persist/lib/storage/session';

import { PREVENT_DETECTING_AUTHENTICATED_USER, SIGN_OUT } from 'constants/redux-actions';

const initState = {};
const persistConfig = { key: 'implicitAuth', storage: sessionStorage };

const implicitAuthReducer = createReducer(initState, {
  [PREVENT_DETECTING_AUTHENTICATED_USER]: () => ({
    isPrevented: true,
  }),
  [SIGN_OUT]: () => ({
    isPrevented: true,
  }),
});

export default persistReducer(persistConfig, implicitAuthReducer);
